import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { CampaignService } from '../../services/campaign.service';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-campaign-donation-settings',
  templateUrl: './campaign-donation-settings.component.html',
  styleUrls: ['./campaign-donation-settings.component.scss']
})
export class CampaignDonationSettingsComponent implements OnInit, OnDestroy {

  @Input() formGroupCampaignTypeData: any = null;

  public takeUntilSubject: Subject<any> = new Subject();

  constructor(
    public campaignService: CampaignService
  ) {}

  ngOnInit(): void {
    const hideRecurring = this.formGroupCampaignTypeData.get('hideRecurring') as UntypedFormControl;
    const frequencyOptions = this.formGroupCampaignTypeData.get('frequencyOptions') as UntypedFormControl;
    
    hideRecurring.valueChanges.pipe(
      filter(value => value),
      takeUntil(this.takeUntilSubject)
    ).subscribe(() => {
      frequencyOptions.clearValidators();
      frequencyOptions.setValue([]);
    });

    hideRecurring.valueChanges.pipe(
      filter(value => !value),
      takeUntil(this.takeUntilSubject)
    ).subscribe(() => {
      frequencyOptions.setValidators([Validators.required]);
      frequencyOptions.setValue([0,1,2]);
    });
    
    this.campaignService.configGroup(this.formGroupCampaignTypeData, this.formGroupCampaignTypeData, 'postActivityFormUrlRequired', [
      { name: 'postActivityFormUrl', defaultValue: "", validators: [Validators.required, Validators.pattern(/^(?:(?:http(s)?):\/\/(www\.)?)[-a-z0-9+&@#\/%?=~_|!:,.;]*[-a-z0-9+&@#\/%=~_|]$/i)] }
    ], this.takeUntilSubject);
  }

  ngOnDestroy() {
    this.takeUntilSubject.next(null);
    this.takeUntilSubject.complete();
  }

}
